// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"739":"dbf44534","861":"643e6d69","881":"558520f5"}[chunkId] + ".chunk.css";
};